import * as React from "react";
import { db } from "../../firebase";
import { Form  , Button } from 'semantic-ui-react'

interface InterfaceProps {
  error?: any;
  history?: any;
  onUserAdded: any;
  username?: string;
  email?: string;
  password?: string;

}

interface InterfaceState {
  error?: any;
  username?: string;
  email?: string;
  password?: string;
}

export class UserAddForm extends React.Component<
  InterfaceProps,
  InterfaceState
> {
  private static INITIAL_STATE = {
    error: null,
    username: "",
    email: "",
    password: ""
  };

  private static propKey(propertyName: string, value: string): object {
    return { [propertyName]: value };
  }

  constructor(props: any) {
    super(props);
    this.state = { ...UserAddForm.INITIAL_STATE };
  }

  public onSubmit = (event: any) => {
    const { username, email, password }: any = this.state;
     const { onUserAdded } = this.props;
     db.doCreateUser(username, email, password)
      .then(() => {
        this.setState(() => ({ ...UserAddForm.INITIAL_STATE }));
        onUserAdded()
      })
      .catch(error => {
        this.setState(UserAddForm.propKey("error", error));
      }); 

    event.preventDefault();
  };

  public render() {
    const { username, email, password , error }: any = this.state;
    const isInvalid = (email === "") || (username === "") || (password === "") ;

    return (
        <Form  onSubmit={event => this.onSubmit(event)}>
          <Form.Field>
            <label>User Name</label>
            <input
              value={username}
              onChange={event => this.setStateWithEvent(event, "username")}
              type="text"
              placeholder="User Name"
            />
          </Form.Field>
          <Form.Field>
            <label>E-mail address</label>
            <input
              value={email}
              onChange={event => this.setStateWithEvent(event, "email")}
              type="email"
              placeholder="E-mail address"
            />
          </Form.Field>
          <Form.Field>
            <label>User Password</label>
            <input
              value={password}
              onChange={event => this.setStateWithEvent(event, "password")}
              type="password"
              placeholder="User Password"
            />
          </Form.Field>
          <Button type='submit' disabled={isInvalid} positive>Save</Button>
          {error && <p>{error.message}</p>}
        </Form>
    );
  }

  private setStateWithEvent(event: any, columnType: string): void {
    this.setState(
      UserAddForm.propKey(columnType, (event.target as any).value)
    );
  }
}


// WEBPACK FOOTER //
// ./src/pills/users/userAddForm.tsx